import React from 'react';
import Button from '@app/react-common/components/button/Button';
import { CopyableField } from '../CopyableField/CopyableField';
import { WarningBanner } from '@app/react-common/components/banners/WarningBanner';
import { EXTENSIONS_AB_TEST_ID_PREFIX } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

const SETUP_GUIDE_URL = 'https://docs.google.com/document/d/1k2JmztzFpfTBDhe2dV2ZnQMBbvg7ISvZVxeFSXFwgh8/edit?tab=t.0';
interface CheckoutProfileTokenTabProps {
  savedAbTestId?: number | null;
  onDone: () => void;
}

export function CheckoutProfileTokenTab({ savedAbTestId, onDone }: CheckoutProfileTokenTabProps) {
  const testId = savedAbTestId ? `${EXTENSIONS_AB_TEST_ID_PREFIX}${savedAbTestId}` : '';

  return (
    <>
      <div className="checkout-profile-token-tab">
        <WarningBanner
          variant="regular"
          hideCloseButton
          title="Launching a test takes two steps"
          content={
            <div className="checkout-profile-token-tab__banner-content">
              <ol className="checkout-profile-token-tab__steps">
                <li>Launch the rollout in Shopify</li>
                <li>Launch the test here</li>
              </ol>
              {SETUP_GUIDE_URL && (
                <Button
                  text="View detailed installation instructions"
                  size="medium"
                  variant="secondary"
                  iconUrl="/assets/icons/external.svg"
                  onClick={() => window.open(SETUP_GUIDE_URL, '_blank', 'noopener,noreferrer')}
                />
              )}
            </div>
          }
        />
        {testId && <CopyableField label="Test ID" value={testId} />}
      </div>
      <div className="ab-test-modal__actions">
        <Button onClick={onDone} text="Done" size="medium" variant="primary" />
      </div>
    </>
  );
}
